import get from 'lodash/get';
import createFacet from './createFacet';
import incCount from './helpers/incCount';
import stringIsEqual from './helpers/stringIsEqual';

export default function createStringFacet(options) {
  const { stateKey, itemKey } = options;
  return createFacet(
    {
      // state, initialValue and prepare are defined in createFacet.

      // The reducer for the facet values.
      reducer: (facetValues, item) =>
        incCount(facetValues, getExt(item, itemKey)),

      // Tests if an item matches a certain filter.
      matches: ({ [stateKey]: filterValues }) => {
        if (!filterValues?.length) return () => true;
        return (item) =>
          filterValues.some((value) =>
            stringIsEqual(getExt(item, itemKey), value)
          );
      },
    },

    options
  );
}

function getExt(item, key, defaultValue) {
  if (typeof key === 'function') return key(item);
  return get(item, key, defaultValue);
}
